<script lang="ts">
    import { Link, useLocation } from "svelte-navigator";
    import Searchbar from "./Searchbar.svelte";
    import moment from "moment";
    import { cart } from "./stores";
    import type { Operation } from "./model";
    import { getContext, onMount } from "svelte";
    import { api } from "./stores";
    import ShareModal from "./modals/ShareModal.svelte";
    import CartPreview from "./cart/CartPreview.svelte";

    const { open, close } = getContext("simple-modal");

    export let operation: Operation;

    let location = useLocation();

    let now = new moment();
    let startDate = new moment();
    let endDate = new moment();
    let displayMemo: boolean;
    let daysLeft = 0;
    let formattedStartDate = "";
    let formattedEndDate = "";

    $: cartCount = $cart.count;

    // get location apge
    $: locationPage = getLocationPage($location);

    onMount(() => {
        if (operation) {
            startDate = new moment(operation.startDate);
            endDate = new moment(operation.endDate);
            displayMemo = !operation.is_paf;

            daysLeft = moment.duration(endDate.diff(now)).as("days");
            if (isNaN(daysLeft)) {
                daysLeft = 0;
            } else {
                daysLeft = Math.ceil(daysLeft);
                formattedStartDate = startDate.format("DD/MM/YYYY");
                formattedEndDate = endDate.format("DD/MM/YYYY");
            }
        }
    });

    /**
     * with location pathname get location to active header location buttons
     * @param location
     */
    function getLocationPage(location): LocationPage {
        let page = LocationPage.HOME;

        let splitLocationPath = location.pathname.split("/");

        if (splitLocationPath.length > 3) {
            let path = splitLocationPath[4];
            switch (path) {
                case "products":
                    page = LocationPage.PRODUCTS;
                    break;
                case "cart":
                    page = LocationPage.CART;
                    break;
                // default
            }
        }
        return page;
    }

    /**
     * Open share modal
     */
    function openShareModal(): void {
        close();
        open(
            ShareModal,
            {
                operation: operation,
            },
            {
                styleWindow: {
                    background: "unset",
                },
            }
        );
    }

    function openCatalogPDF(): void {
        window.open(`${$api.getBaseUrl()}/pdf`, "_blank");
    }

    enum LocationPage {
        HOME,
        PRODUCTS,
        CART,
    }
</script>

<nav class="navbar">
    <!-- Logo -->
    <div class="navbar-brand">
        <a class="navbar-item logo" href="">
            <img src="/nanotera.svg" alt="" />
        </a>
    </div>
    <!-- campaign name and date -->
    <div id="navbarEcat" class="navbar-menu">
        <div class="navbar-start">
            <div
                class="date navbar-item is-flex-direction-column is-align-items-flex-start is-justify-content-space-evenly is-flex-shrink-1"
            >
                <div class="catalog-name">{operation.name}</div>
                <div class="catalog-date">
                    {#if formattedStartDate !== "" && formattedEndDate !== ""}
                        Du {formattedStartDate} Au {formattedEndDate}
                        <b>
                            Plus que
                            {daysLeft} jours !</b
                        >
                    {/if}
                </div>
            </div>
        </div>

        <div class="navbar-item search-bar mobile-button" style="">
            {#if operation && !operation.is_paf}
                <Searchbar />
            {/if}
        </div>

        <div class="navbar-end">
            <!-- List of buttons header -->
            <div class="navbar-item">
                <div class="buttons">
                    {#if !operation.is_paf}
                        {#if operation.show_paf}
                            <Link to="">
                                <button
                                    class="button btn-icon is-navigation"
                                    title="Acceder au catalogue"
                                    class:is-active={locationPage ==
                                        LocationPage.HOME}
                                >
                                    <span class="icon">
                                        <i class="fas fas fa-book-open" />
                                    </span>
                                    Le catalogue
                                </button>
                            </Link>
                        {/if}
                        <!-- {#if locationPage !== LocationPage.PRODUCTS} -->
                        <Link to="products">
                            <button
                                class="button btn-icon is-navigation"
                                title="Acceder aux promotions"
                                class:is-active={locationPage ==
                                    LocationPage.PRODUCTS}
                            >
                                <span class="icon">
                                    <i class="fas fa-th" />
                                </span>
                                Promotions
                            </button>
                        </Link>
                        <!-- {/if} -->

                        <div class="dropdown is-hoverable">
                            <div class="dropdown-trigger">
                                <Link to="cart">
                                    <div
                                        id="cart"
                                        class="button btn-icon is-navigation"
                                        title="Mon panier"
                                        class:is-active={locationPage ==
                                            LocationPage.CART}
                                        data-counter={$cartCount > 0
                                            ? $cartCount.toString()
                                            : null}
                                    >
                                        <span class="icon">
                                            <i class="fas fa-shopping-bag" />
                                        </span>
                                    </div>
                                </Link>
                            </div>
                            <div
                                class="dropdown-menu"
                                id="dropdown-cart"
                                role="menu"
                            >
                                <div class="dropdown-content">
                                    <div
                                        class="dropdown-item"
                                        style="width: 30rem;"
                                    >
                                        <CartPreview />
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/if}

                    <div class="pipe" />

                    {#if operation && !operation.is_paf}
                        <div class="search-bar">
                            <Searchbar />
                        </div>
                    {/if}
                    <button
                        class="button btn-icon"
                        title="Télécharger PDF"
                        on:click={() => openCatalogPDF()}
                    >
                        <span class="icon">
                            <i class="fas fa-file-download" />
                        </span>
                    </button>

                    <!-- Share -->
                    <button
                        class="button btn-icon"
                        title="Partager le catalogue"
                        on:click={() => {
                            openShareModal();
                        }}
                    >
                        <span class="icon">
                            <i class="fas fa-share-alt" />
                        </span>
                    </button>

                    <div class="pipe" />
                </div>
            </div>

            <div class="navbar-item button shop-info">
                <h5>
                    <!-- <i class="fas fa-store-alt" /> -->
                    {operation.shopName}
                </h5>
            </div>
        </div>
    </div>
</nav>

<!-- Mobile footer navbar -->
<nav class="navbar is-fixed-bottom mobile-navbar">
    <div class="navbar-brand">
        {#if !operation.is_paf}
            {#if operation.show_paf}
                <div class="navbar-item is-expanded is-block has-text-centered">
                    <Link to="">
                        <button
                            class="button is-navigation"
                            class:is-active={locationPage == LocationPage.HOME}
                            title="Acceder au catalogue"
                        >
                            <span class="icon">
                                <i class="fas fas fa-book-open" />
                            </span>
                        </button>
                    </Link>
                </div>
            {/if}
            <div class="navbar-item is-expanded is-block has-text-centered">
                <Link to="products">
                    <button
                        class="button is-navigation"
                        class:is-active={locationPage == LocationPage.PRODUCTS}
                        title="Acceder aux promotions"
                    >
                        <span class="icon">
                            <i class="fas fa-th" />
                        </span>
                    </button>
                </Link>
            </div>
            <div class="navbar-item is-expanded is-block has-text-centered">
                <Link to="cart">
                    <div
                        id="cart"
                        class="button is-navigation"
                        class:is-active={locationPage == LocationPage.CART}
                        title="Mon panier"
                        data-counter={$cartCount > 0
                            ? $cartCount.toString()
                            : null}
                    >
                        <span class="icon">
                            <i class="fas fa-shopping-bag" />
                        </span>
                    </div>
                </Link>
            </div>
        {/if}

        <div class="navbar-item is-expanded is-block has-text-centered">
            <button
                class="button"
                title="Télécharger PDF"
                on:click={() => openCatalogPDF()}
            >
                <span class="icon">
                    <i class="fas fa-file-download" />
                </span>
            </button>
        </div>

        <!-- Share -->
        <div class="navbar-item is-expanded is-block has-text-centered">
            <button
                class="button"
                title="Partager le catalogue"
                on:click={() => {
                    openShareModal();
                }}
            >
                <span class="icon">
                    <i class="fas fa-share-alt" />
                </span>
            </button>
        </div>

        <div
            class="navbar-item is-expanded is-block has-text-centered shop-info "
        >
            <h5>
                <i class="fas fa-store-alt" />
                {operation.shopName}
            </h5>
        </div>
    </div>
</nav>

<style lang="scss">
    @import "./styles/variables.scss";

    .navbar {
        height: $header-height;

        @media (max-width: $mobile-breakpoint) {
            height: unset;
        }
        background-color: $light-white;
        .navbar-end {
            align-items: center;
        }

        border-bottom: 1px solid $dark-black;
    }
    .navbar-menu {
        background-color: $light-white;
    }

    .logo {
        margin: auto;
        padding: 1rem;
    }

    .shop-info {
        cursor: default;
        display: block;
        background-color: $light-lavender !important;
        margin: auto;
        color: black;
        border-radius: 10px;
        margin-right: 5px;
    }
    .date {
        @media (min-width: $mobile-breakpoint) {
            padding-left: 0px;
        }
    }

    #navbarEcat {
        @media (max-width: $mobile-breakpoint) {
            display: flex;
            padding: unset;
            .navbar-end {
                display: none;
            }

            .search-bar {
                padding: 2px;
            }
        }
    }

    .mobile-navbar {
        border-top: 1px solid;
        @media (min-width: $mobile-breakpoint) {
            display: none;
        }
        .button {
            border: none;
            height: 2rem;
            color: $dark-black;
        }
        h5 {
            font-size: 10px;
        }
    }

    .mobile-button {
        margin-left: auto;
        @media (min-width: $mobile-breakpoint) {
            display: none;
        }
    }

    .buttons {
        gap: 0.5rem;
    }

    #dropdown-cart {
        right: 0;
        left: unset;
    }

    #cart {
        position: relative;
        #cart-counter {
            background-color: $dark-mauve;
            color: white;
            position: absolute;
            top: 0;
            right: 0;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            vertical-align: middle;
            text-align: center;
        }

        &[data-counter] {
            position: relative;
            &:after {
                position: absolute;
                right: 0px;
                top: -10px;
                width: 25px;
                height: 25px;
                line-height: 10px;
                padding: 5px;
                color: white;
                background-color: $dark-mauve;
                font-size: 10px;
                border-radius: 20px;
                content: attr(data-counter);
                border: solid 1px $dark-mauve;
                z-index: 10;
            }
        }
    }

    .catalog-name {
        font-size: 14pt;
        line-height: 1.25;
        color: $dark-black;
        font-family: "Diagramm Bold";
        @media (max-width: $mobile-breakpoint) {
            font-size: 10pt;
        }
    }

    .catalog-date {
        font-size: 12pt;
        font-family: "Gilmer Medium";
        color: #000000;
        @media (max-width: $mobile-breakpoint) {
            font-size: 8pt;
        }
        b {
            color: $dark-mauve;
            font-size: 10pt;
            font-weight: bold;
        }
    }

    .is-navigation {
        span {
            margin-right: 2px !important;
        }

        &.is-active {
            :nth-child(1) {
                border-bottom: $dark-black solid 1px !important;
            }
        }
    }

    #dropdown-menu {
        min-width: unset;
    }

    .pipe {
        width: 1px;
        height: 25px;
        background: $grey-light;
    }
</style>
